import {reduxForm, Field} from 'redux-form'
import {connect} from 'react-redux'
import DropdownOutlet from 'components/Fields/ReduxForm/DropdownOutlet'
import DropdownCalendar from 'components/Fields/ReduxForm/DropdownCalendar'
import MultipleDropdownSelect from 'components/Fields/ReduxForm/MultipleDropdownSelect'
import SearchBar from 'components/Fields/ReduxForm/SearchBar'
import OutletModal from 'components/Fields/ReduxForm/OutletModal'
import styleActionBar from './ActionBar.css'
class ActionBar extends React.Component {
  static INVOICE_STATUS = {
    'cancelled': 'Cancelled',
    'unpaid': 'Unpaid',
    'overdue': 'Overdue',
    'paid': 'Paid',
    'partially_paid': 'Partially Paid'
  }
  constructor (props) {
    super(props)
    this.state = {
      showModal: false
    }
  }

  render () {
    const {outlets, showModalOutletMobileState} = this.props
    return (<div>
      <div className={`${styleActionBar['form-group']} form-group pull-left visible-md visible-lg no-margin`}>
        <Field
          component={DropdownOutlet}
          outlets={outlets}
          onChangeOutletIds={this._onChangeOutlet}
          name='outlet'
          allOutletOption
        />
      </div>
      <div className={`${styleActionBar['form-group']} calendar-dashboard pull-left`}>
        <Field
          component={DropdownCalendar}
          name='date'
          onChange={this._onChangeDate}
          updateServerOnChange
        />
      </div>
      <div className={`${styleActionBar['form-group']}  visible-md visible-lg pull-left`}>
        <Field
          component={MultipleDropdownSelect}
          name='statuses'
          onChange={this._onChangeStatuses}
          options={ActionBar.INVOICE_STATUS}
          placeholder='Select Status'
        />
      </div>
      <div className={`${styleActionBar['form-group']}  visible-md visible-lg pull-left`}>
        <Field
          component={SearchBar}
          name='keyword'
          onChange={this._onChangeKeyword}
          placeholder='Search'
        />
      </div>
      <Field
        component={OutletModal}
        name='outlet'
        outlets={outlets}
        onChangeOutletIds={this._onChangeOutlet}
        allOutletOption
        show={showModalOutletMobileState}
      />
    </div>)
  }

  _onChangeOutlet = (outletIds) => {
    this.props.onChangeOutlet(outletIds)
  };

  _onChangeDate = ({startDate, endDate}) => {
    this.props.onChangeDate({startDate, endDate})
  };

  _onChangeStatuses = (event, statuses) => {
    this.props.onChangeStatuses(statuses)
  }

  _onChangeKeyword = (event, keyword) => {
    this.props.onChangeKeyword(keyword)
  }
}

const mapForm = {
  form: 'search'
}

function mapStateToProps (state) {
  return {
    outlets: state.reports.invoices.outlets,
    showModalOutletMobileState: state.moka.showModalOutletMobile
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

ActionBar.propTypes = {
  onChangeOutlet: React.PropTypes.func,
  onChangeDate: React.PropTypes.func,
  onChangeStatuses: React.PropTypes.func,
  onChangeKeyword: React.PropTypes.func
}

export default reduxForm(mapForm)(connect(mapStateToProps, mapDispatchToProps)(ActionBar))



// WEBPACK FOOTER //
// ./app/pages/Reports/Invoices/ActionBar/ActionBar.js